import { useEffect, useRef } from 'react';
import { Center } from '@react-three/drei';
import Arm from '../assets/ccr/Arm.jsx';
import ArmSupport from '../assets/ccr/ArmSupport.jsx';
import Plunger from '../assets/ccr/Plunger.jsx';
import Rods from '../assets/ccr/Rods.jsx';
import Sensor from '../assets/ccr/Sensor.jsx';
import Springs from '../assets/ccr/Springs.jsx';
import Support from '../assets/ccr/Support.jsx';
import gsap from 'gsap';


export default function Ccr({ position = [0, -40, 0], rotation = [0, Math.PI/2, 0], scale = [0.72, 0.72, 0.72], isActive = false, isVisible = true}) {
    const armRef = useRef();
    const plungerRef = useRef();
    const springsRef = useRef();
    const sensorRef = useRef();
    const rodsRef = useRef();
    const supportRef = useRef();
    const suppRef = useRef();

    const setCcrOpacity = (opacity) => {
        gsap.to(armRef.current.material, { opacity, duration: 1 });
        gsap.to(plungerRef.current.material, { opacity, duration: 1 });
        gsap.to(springsRef.current.material, { opacity, duration: 1 });
        gsap.to(sensorRef.current.material, { opacity, duration: 1 });
        gsap.to(rodsRef.current.material, { opacity, duration: 1 });
        gsap.to(supportRef.current.material, { opacity, duration: 1 });
        gsap.to(suppRef.current.material, { opacity, duration: 1 });
    };

    const lowerCcr = () => {
        gsap.to(supportRef.current.position, { y: -0.068, duration: 1.2, ease: 'power1.out' });
        gsap.to(armRef.current.position, { y: -0.164, duration: 1.2, ease: 'power1.out' });
        gsap.to(plungerRef.current.position, { y: -0.37, duration: 1.2, ease: 'power1.out' });
        gsap.to(springsRef.current.scale, { y: 1.46, duration: 1.2, ease: 'power1.out' });
        gsap.to(sensorRef.current.position, { y: -0.234, duration: 1.2, ease: 'power1.out' });
        gsap.to(rodsRef.current.position, { y: -0.298, duration: 1.2, ease: 'power1.out' });

        gsap.to(armRef.current.rotation, { z: -Math.PI/12, duration: 1.2, ease: 'power1.out' });
        gsap.to(plungerRef.current.rotation, { z: -Math.PI/10, duration: 1.2, ease: 'power1.out' });
        gsap.to(sensorRef.current.position, { y: -0.410, x: 0.65, duration: 1.2, ease: 'power1.out' });
        gsap.to(rodsRef.current.rotation, { z: -Math.PI/12, duration: 1.2, ease: 'power1.out' });
    };

    const raiseCcr = () => {
        gsap.to(supportRef.current.position, { y: 0.03, duration: 1.2, ease: 'power1.out' });
        gsap.to(armRef.current.position, { y: -0.066, duration: 1.2, ease: 'power1.out' });
        gsap.to(plungerRef.current.position, { y: -0.272, duration: 1.2, ease: 'power1.out' });
        gsap.to(springsRef.current.scale, { y: 1, duration: 1.2, ease: 'power1.out' });
        gsap.to(sensorRef.current.position, { y: -0.136, duration: 1.2, ease: 'power1.out' });
        gsap.to(rodsRef.current.position, { y: -0.2, duration: 1.2, ease: 'power1.out' });

        gsap.to(armRef.current.rotation, { z: 0, duration: 1.2, ease: 'power1.out' });
        gsap.to(plungerRef.current.rotation, { z: 0, duration: 1.2, ease: 'power1.out' });
        gsap.to(sensorRef.current.position, { y: -0.136, x: 0.69, duration: 1.2, ease: 'power1.out' });
        gsap.to(rodsRef.current.rotation, { z: 0, duration: 1.2, ease: 'power1.out' });
    };

    useEffect(() => {
        if (isActive) {
            lowerCcr();
        } else {
            raiseCcr();
        }
    }, [isActive]);

    useEffect(() => {
        if (isVisible) {
            setCcrOpacity(1);
        } else {
            setCcrOpacity(0);
        }
    }, [isVisible]);

    return (
        <>  
            <group position={position} rotation={rotation} scale={scale}>
                <Center>
                    <ArmSupport ref={supportRef} position={[-0.036, 0.03, 0.022]} scale={[1,1,1]} rotation={[0, 0, 0]} />
                    <Arm ref={armRef} position={[-0.014, -0.066, 0.022]} scale={[1,1,1]} rotation={[0, 0, 0]} />
                    <Plunger ref={plungerRef} position={[0.08, -0.272, 0.022]} scale={[1,1,1]} rotation={[0, 0, 0]} />
                    <Springs ref={springsRef} position={[-0.084, 0.2, 0.022]} scale={[1,1,1]} rotation={[0, 0, 0]} />
                    <Sensor ref={sensorRef} position={[0.69, -0.136, 0.022]} scale={[1,1,1]} rotation={[0, 0, 0]} />
                    <Rods ref={rodsRef} position={[-0.022, -0.2, 0.022]} scale={[1,1,1]} rotation={[0, 0, 0]} />
                    <Support ref={suppRef}/> 
                </Center>
            </group>
        </>
    );
}
